import React from "react"
import { Container } from 'react-bootstrap';
import Select from 'react-select';
import $ from "jquery";
import algoliasearch from "algoliasearch/lite"

import { Link } from "@StarberryUtils";
import { navigate } from "@reach/router"
import { isMobile, isMobileOnly } from "react-device-detect";
import { motion } from "framer-motion";
import { InView } from "react-intersection-observer";
import Loadable from "@loadable/component"

import MapResultsDesktop from '../components/property-search/mapview-desktop';
import SaveProperty from "../components/property-search/saveProperty";

import SeoResults from "../components/property-search/seoResults"
import CommercialSeoResults from "../components/property-search/commercialseoResults"
import NewhomeSeoResults from "../components/property-search/newhomeseoResults"

import SearchResultsFilterResiSales from "../components/search-results-filter/SearchResultsFilterResiSales";
import SearchResultsFilterResiRentals from "../components/search-results-filter/SearchResultsFilterResiRentals";
import SearchResultsFilterCommSales from "../components/search-results-filter/SearchResultsFilterCommSales";
import SearchResultsFilterCommRentals from "../components/search-results-filter/SearchResultsFilterCommRentals";
import SearchResultsFilterNewSales from "../components/search-results-filter/SearchResultsFilterNewSales";

import ResultList from "../components/ResultList/ResultList";
import NoResults from "../components/ResultList/NoResults";
import { inViewOptions } from '../components/utils/animations';
import HeaderTwo from "../components/headerTwo/headerTwo"
import Footer from "../components/footer/footer"
import CanHelp from "../components/Home/CanHelp/CanHelp"
import { ApiRequest } from "../utils/api_request_utils";
import { parseSearchUrl, propertyH1, savedSearchParams } from "../components/property-search/utils";

import "../scss/custom.scss";
import "../pages/property/assets/styles/_index.scss"

// import noPropertyData from "../../static/nopropertydatasales.json"

const MapResultsMobile = Loadable(() => import("../components/map/search-results-mobile-map"));

const { parseResultsUrl, generateFiltersfromPageData } =  require("../gatsby-library-common/PropertySearchNew")

const index_name = `${process.env.GATSBY_ALGOLIA_INDEX_NAME}`
const DEFAULT_AREA = 'London'
const containerVariants = {
  hidden: {
    opacity: 0,
    y: 60,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      ease: [0.33, 1, 0.68, 1],
      duration: 0.1
    }
  }
}

// Dropdown react select styles
const customStyles = {
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
        return {
            ...styles,
            backgroundColor: isFocused ? "#005480" : null,
            color: isFocused ? "#ffffff" : "#575757"
        };
    },
    control: styles => ({
        ...styles,
        backgroundColor: null,
        border: 0,
        paddingLeft: 0,
        outline: 0,
        boxShadow: 'none',
        color: '#005480',
        fontSize: '1.25rem',
        fontWeight:'normal'
    }),
    valueContainer: (styles) => ({
        ...styles,
        fontSize: '1.25rem',
        paddingLeft: 0,
        lineHeight: '30px',
        fontWeight:'normal',
        cursor: 'pointer'
    }),
    dropdownIndicator: (styles) => ({
        ...styles,
        color: "#ffffff",
    }),
    indicatorsContainer: (styles) => ({
        ...styles,
        color: '#ffffff',
        cursor: 'pointer'
    }),
    indicatorSeparator: () => null,
    placeholder: (defaultStyles) => {
        return {
            ...defaultStyles,
            color: '#515862',
            marginLeft: 0
        }
    },
  }
  
  const DownIndicator = () => (
    <>
        <i className={ "icon icon-dropdown-arrow" }></i>
    </>
  )
  // Dropdown react select styles

const updateAfter = 500

var minpriceval = minpriceval || ""
var maxpriceval = maxpriceval || ""


// Active filter onscroll
let lastScrollY = 0
let activeHeader = ""
// Active filter onscroll

class SearchResultTemplate extends React.Component {
    isUserInteraction = true;

    constructor(props) {
        super(props);
    }
    
    /* ========= Local Cache =========== */
    local_storage_data = typeof window !== 'undefined' &&  localStorage.getItem('algolia_data') ? JSON.parse(localStorage.getItem('algolia_data')) : [];

    //
    state = {
        //searchState: urlToSearchState(this.props.location),

        algoliadata: [],
        my_page_url_data: [],
        chkalgolia: true,
        userObjects: this.props.userObjects,
        mapview: false,
        includeSold: true, // Include sold property
        mustIncludes: [],
        status: this.props.status,

        local_cache: this.local_storage_data  // ========= Local Cache ===========  
    }

    componentDidUpdate(prevProps) {
        if (prevProps.location.pathname !== this.props.location.pathname) {

            this.isUserInteraction = true;
            this.getAlgoliaResults();

          // if (this.props.location.pathname.includes("with-") || this.props.location.pathname.includes("include-")) {
          //   let pathUri_main = this.props.location.pathname.split("/property/for-sale")
          //   if (pathUri_main[1]) {
          //     let pathUri = pathUri_main[1].split("/");
          //     let includeUrls = pathUri.filter(c => c.includes("with"))
          //     if(includeUrls.length > 0) {
          //         let includeUrl = includeUrls[0];
          //         var mustIncludeArrfilt = includeUrl.replace("with-", "")
          //         let vals = mustIncludeArrfilt.split("-and-")
          //         this.setState({ mustIncludes: vals })
          //       }
          //       if(pathUri.includes("available")) {
          //         this.setState({ includeSold: false })
          //       }
          //     }
          // }
          
          // // Include sold available start
          // if(this.props.location.pathname.includes("available")) {
          //   this.setState({ includeSold: false })
          // } else {
          //   this.setState({ includeSold: true })
          // }
          // Include sold available end

            // this.setState({ searchState: urlToSearchState(this.props.location) })
        }
    }
    componentDidMount() {
    
        this.getAlgoliaResults();  

        // let pathUri_main = this.props.location.pathname.split("/property/for-sale")
        // if (pathUri_main[1]) {
        // let pathUri = pathUri_main[1].split("/");
        // let includeUrls = pathUri.filter(c => c.includes("with"))
        // if(includeUrls.length > 0) {
        //     let includeUrl = includeUrls[0];
        //     var mustIncludeArrfilt = includeUrl.replace("with-", "")
        //     let vals = mustIncludeArrfilt.split("-and-")
        //     this.setState({ mustIncludes: vals })
        //   }
        //   if(pathUri.includes("available")) {
        //     this.setState({ includeSold: false })
        //   }
        // }
        // Must Include

      $(document).mouseup(function(e)
      {
          var container = $(".dropdown-exp");

          // if the target of the click isn't the container nor a descendant of the container
          if (!container.is(e.target) && container.has(e.target).length === 0)
          {
          $(".dropdown-exp").removeClass("active");
          }
      });

      

        window.addEventListener("scroll", this.handleScroll, true)

        if(sessionStorage.getItem('searchindex') != null){
          if(sessionStorage.getItem('tabView') != null && sessionStorage.getItem('tabView') === 'mapview'){
          $(".results-view").addClass("map-veiw-content");
          }

          var idelement = "mySaleProp"+sessionStorage.getItem('searchindex');
          setTimeout(function() {
            var elmnt = document.getElementById(idelement.toString());
            if(elmnt){
            elmnt.scrollIntoView();
            sessionStorage.removeItem('searchindex')
            }
        }, 1);
        }
        else {
           // load on top
        $(document).ready(function(){
          $("html, body").scrollTop(0)
        });
        // load on top
        }


        // Info button seo text
        $(".icon-finder").click(function() {
          $(".search_text").toggleClass("active")
        })
        // Info button seo text

        // Sold filter
        $( ".must_include_sold" ).insertAfter( ".property_sold_fitler" );
        $( ".must_include_sold_mob" ).insertAfter( ".property_sold_fitler_mob" );
        // Sold filter

        // Let filter
        // $( ".filtersearchsoldlet" ).insertAfter( ".defaultsoldfilter" );
        $( ".must_include_let" ).insertAfter( ".property_sold_fitler" );
        $( ".must_include_let_mob" ).insertAfter( ".property_sold_fitler_mob" );
        // Let filter
    }

    // Filter active onscroll
    componentWillUnmount() {
      window.removeEventListener("scroll", this.handleScroll)

      window.removeEventListener('popstate', this.onPopState);
    }

    onPopState = ({ state }) => {
        this.setState({
            searchState: state || {},
        });
    }

    handleScroll = () => {
      lastScrollY = window.scrollY

      if (lastScrollY > 200) {
        activeHeader = "active-scroll"
      } else if (lastScrollY < 200) {
        activeHeader = ""
      }

      this.setState({ activeHeader })
    }
    // Filter active onscroll



    // Map & List View
    listView = (e) => {
      $(".results-view").removeClass("map-veiw-content");
      sessionStorage.setItem('tabView', 'listview')
    }

    mapView = (e) => {
      $(".results-view").addClass("map-veiw-content");
      sessionStorage.setItem('tabView', 'mapview')
    }

    listViewMobile = (e) => {
      $(".results-view").removeClass("map-veiw-content");
      $(".list-mobile").removeClass("active")
      $(".map-mobile").addClass("active")
      this.setState({mapview: false});
      sessionStorage.setItem('mobileView', 'listview')
    }

    mapViewMobile = (e) => {
      $(".results-view").addClass("map-veiw-content");
      $(".list-mobile").addClass("active")
      $(".map-mobile").removeClass("active")
      this.setState({mapview: true});
      sessionStorage.setItem('mobileView', 'mapview')
    }
    // Map & List View

    getAlgoliaResults = () => {
        const page_url_data = parseResultsUrl(this.props.location)
        this.setState({ my_page_url_data: page_url_data })

        let myalgoliafilters = generateFiltersfromPageData(page_url_data['departmentVal'], page_url_data['searchtypeVal'], page_url_data['areaVal'], page_url_data['bedVal'],page_url_data['bedValPlus'], page_url_data['minpriceVal'], page_url_data['maxpriceVal'], page_url_data['buildingval'], page_url_data['mustincludeVal'], page_url_data['furnishVal'], page_url_data['branchVal'], page_url_data['minfloorVal'], page_url_data['maxfloorVal'])

        let mystatus = ''
        if(page_url_data['statusVal']){
          mystatus = '(status:"'+(page_url_data['statusVal'])+'")'
        } else{
          if(Array.isArray(this?.state?.status)){
            mystatus = '(status:"'+(this.state.status).join('" OR status:"')+'")'
          } else {
            mystatus = '(status:"'+(this.state.status)+'")'
          }
        }
        myalgoliafilters += ' AND '+mystatus

        let building_val = ["house", "semi-detached-house", "detached-house"]
        let mybuilding = ''

        if(page_url_data['buildingval'] && page_url_data['buildingval']!="new-home"){
          if(page_url_data['buildingval'] === "house"){
            mybuilding = '(building:"'+(building_val).join('" OR building:"')+'")'
          } else{
            mybuilding = '(building:"'+(page_url_data['buildingval'])+'")'
          }

          myalgoliafilters += ' AND '+mybuilding
        }
        

        //myalgoliafilters += ' AND (publish:true)'
        //console.log("prestige_property",this.props?.location?.state)
        // console.log("myalgoliafilters",myalgoliafilters)
        const client = algoliasearch(process.env.GATSBY_ALGOLIA_APP_ID, process.env.GATSBY_ALGOLIA_SEARCH_KEY);
        const index = client.initIndex(page_url_data['sortVal'] ? page_url_data['sortVal'] : page_url_data['indexVal']);

        /* ========= Local Cache =========== */
        let path_name = typeof window !== 'undefined' ? window.location.href : ''
        var expTime = new Date().setMinutes(new Date().getMinutes() + 5);
        let filter_local_cache = this.filterLocalCache(path_name);

        let hits_per_page = (isMobile && this.state.mapview) ? 2000 : 16

        //console.log("filter_local_cache", filter_local_cache)
        
        
        if(filter_local_cache?.length > 0 && myalgoliafilters === filter_local_cache[0][path_name].filter_data){
            //console.log("algoliadata 1", filter_local_cache)
            let get_data = filter_local_cache[0];
            let get_data_pathname = get_data[path_name]
            //console.log("get_data ==>", get_data_pathname);

            if(get_data_pathname?.total > 0){
                this.setState({
                    algoliadata: get_data_pathname,
                    noResultProperties: []
                })
            } else{
                this.setState({ algoliadata: [] })
                this.getNoResultProperties();
            }
            
        } else{

            if (this.isUserInteraction) {
                index.search((page_url_data['areaVal'] === (DEFAULT_AREA).toLowerCase() ? '' : page_url_data['areaVal']), {
                    filters: myalgoliafilters,
                    page: (page_url_data['pageVal'] - 1),
                    hitsPerPage: 16
                }).then(({ nbHits, page, hitsPerPage, nbPages, hits }) => {
                    //console.log("hits ==>", hits, nbHits)
                    
                    /* ========= Local Cache expTime =========== */
                    let myArray = { "total": nbHits, "current_page_number": page, "hitsPerPage": hitsPerPage, "number_of_pages": nbPages, "hits": hits, expTime: expTime, filter_data: myalgoliafilters };
                    
                    if(nbHits > 0){
                        this.setState({ algoliadata: myArray, noResultProperties: [] })
                        this.isUserInteraction = false;
                        this.forceUpdate();
                    }
                    else{
                        this.setState({ algoliadata: [] })
                        this.getNoResultProperties();
                    }

                    /* ========= Local Cache =========== */
                    this.setState({
                        local_cache: [...this.state.local_cache, {[path_name]: myArray}]
                        }, () => localStorage.setItem('algolia_data', JSON.stringify(this.state.local_cache))
                    )

                });
            }

        }
    }

    /* ========= Local Cache =========== */
    filterLocalCache = (path_name) => {
        let get_local_cache = this.state.local_cache;
        let filter_local_cache = [];
        // filter_local_cache = get_local_cache.length > 0 && get_local_cache.filter(key => key[path_name]);

        if(get_local_cache?.length > 0){
            let remove_local_cache =  get_local_cache?.filter(key => Object.values(key)[0]?.expTime > (new Date().getTime()))

            this.setState({
                local_cache: remove_local_cache
                }, () => localStorage.setItem('algolia_data', JSON.stringify(remove_local_cache))
            )

            filter_local_cache = remove_local_cache?.length > 0 && remove_local_cache?.filter(key => key[path_name]);
        }

        //console.log("algoliadata 2", path_name, this.state.local_cache, filter_local_cache)

        return filter_local_cache;
    }

    onChangeSortBy = (event) => {
      let location_path_remove = this?.props?.location?.pathname.replace('sortby-price-desc/', '').replace('sortby-price-asc/', '').replace('sortby-most-recent/', '')
      navigate(location_path_remove+event.path+"/")
    }

    getNoResultProperties = () => {
        var status_filter = "For Sale"

        if(this.props.search_type === "lettings"){
            status_filter = "To Let"
        }

        ApiRequest({
            method: "GET",
            url: `${process.env.GATSBY_STRAPI_SRC}/properties?search_type=${this.props.search_type}&_limit=6&_sort=published_at:DESC&publish=true&department=${this.props.department}&status=${status_filter}`,
            headers: {
                Authorization: `Bearer ${process.env.GATSBY_STRAPI_FORM_TOKEN}`,
            }
            
        }, (result) => {
            if (result.length > 0 && (this.props.path.indexOf("/property/new-homes/for-sale/")==-1) || (this.props.path.indexOf("type-new-home")==-1)) {
                this.setState({ noResultProperties: result })
            }
        })
    }

    // Refine your results
    refineFilterResults = (e) => {
      $(".filter-toggle").toggleClass("active");
      $(".filters-form").toggleClass("active-filter");
    }
    // Refine your results

    //
    // getMustInclude = () => {

    // }
    //

    render () {

        //const { searchState, noResultProperties, includes, my_page_url_data } = this.state;
        // const searchParams = propertySearchParams({ ...this.props, my_page_url_data })

        const searchParams = parseSearchUrl(this.props.search_type, this.props.location.pathname, this.props.path, this.props.department);
        const saveSearchParams = savedSearchParams(searchParams);
        const h1 = propertyH1(searchParams);
        const areaName = searchParams.areas;
        const pType = searchParams.pType;

        const isPageLoadBg = (typeof this.props.path === "undefined");

        let titleh1 = h1//.replace("Apartment", "Apartments").replace("House", "Houses").replace("Bungalow", "Bungalows").replace("New-home", "New-homes").replace(/-/g, " ")

        titleh1 = titleh1.trim();

        let search_summarytxt = titleh1.charAt(0).toLowerCase() + titleh1.slice(1);

        console.log("noResultProperties", this.state.noResultProperties);

        return (
            <>
              <HeaderTwo page="results" />

              {!isPageLoadBg && 
                (this?.props?.department === "residential" ?
                  <SeoResults title={this?.props?.pageContext?.title ? this?.props?.pageContext?.title : h1} description={this?.props?.pageContext?.desc} searchParams={searchParams} location={this?.props?.location?.pathname != this.props.path ? this?.props?.location : ""} />
                : this?.props?.department === "commercial" ?
                  <CommercialSeoResults title={this?.props?.pageContext?.title ? this?.props?.pageContext?.title : h1} description={this?.props?.pageContext?.desc} searchParams={searchParams} location={this?.props?.location?.pathname != this.props.path ? this?.props?.location : ""} />
                :
                  <NewhomeSeoResults title={this?.props?.pageContext?.title ? this?.props?.pageContext?.title : h1} description={this?.props?.pageContext?.desc} searchParams={searchParams} location={this?.props?.location?.pathname != this.props.path ? this?.props?.location : ""} />
                )
              }

                <div className="content result-list-content">
                    <div className={activeHeader + " search-filters"}>
                        {(this?.props?.department === "residential" && this?.props?.search_type === "sales") ?            <SearchResultsFilterResiSales />
                        : (this?.props?.department === "residential" && this?.props?.search_type === "lettings") ? <SearchResultsFilterResiRentals />
                        : (this?.props?.department === "commercial" && this?.props?.search_type === "sales") ? <SearchResultsFilterCommSales />
                        : (this?.props?.department === "commercial" && this?.props?.search_type === "lettings") ? <SearchResultsFilterCommRentals />
                        : (this?.props?.department === "new_developments" && this?.props?.search_type === "sales") ? <SearchResultsFilterNewSales />
                        : ''
                        }
                    </div>

                    <section className="result-map results-view">
                      <div className="list-view-wrap">
                        <Container>
                        <div className ="results-detail res-sale-only-results">
                            <InView {...inViewOptions}>
                            {({ ref, inView }) => (
                                <motion.div
                                className="result-head res-sale-results"
                                ref={ref}
                                initial="hidden"
                                animate={inView ? "visible" : "hidden"}
                                variants={containerVariants}
                                >
                                <div className="d-md-flex justify-content-between">
                                    <div className="result-info">
                                        <h1 className="search-results-h1">{titleh1} <strong>({this.state.algoliadata?.total > 0 ? this.state.algoliadata?.total : 0})</strong><i className="icon-finder"></i> <span className="wishlist-icon-search-heading"><SaveProperty type="search" searchParams={saveSearchParams} userObjects={this.state.userObjects}/></span></h1>
                                        {/* <SaveProperty type="search" searchParams={saveSearchParams} userObjects={this.state.userObjects}/> */}
                                    </div>

                                    {(this?.props?.department === "residential" && this?.props?.search_type === "sales") && 
                                      <div className="d-md-none">
                                          <Link to="/property/commercial/for-sale/in-london" className="commercial-property-link-mobile">View Commercial Property</Link>
                                      </div>
                                    }

                                    <ul className="view-list d-md-none d-flex align-items-center">
                                        <li>
                                          <div className="property_sold_fitler_mob"></div>
                                        </li>
                                        <li className="property_sortby">
                                            {/* <Link to="#">Highest Price First </Link> */}
                                            
                                            <div className="search-select-box sortby-dropdown">
                                                <Select
                                                    name="sortby"
                                                    options={[
                                                    { value: index_name+"_price_desc", label: "Highest Price First", path: "sortby-price-desc" },
                                                    { value: index_name+"_price_asc", label: "Lowest Price First", path: "sortby-price-asc" },
                                                    { value: index_name+"_most_recent", label: "Most Recent First", path: "sortby-most-recent" },
                                                    ]}
                                                    placeholder="Highest Price"
                                                    classNamePrefix={"select-opt"}
                                                    isSearchable={false}
                                                    components={{ DropdownIndicator: () => <DownIndicator /> }}
                                                    onChange={this.onChangeSortBy}
                                                />
                                            </div>
                                        </li>
                                        <li className="list-ctrl list-mobile align-items-center"><a href="javascript:void(0)" onClick={this.listViewMobile}>Grid View</a></li>
                                        <li className="map-ctrl map-mobile align-items-center active"><a href="javascript:void(0)" onClick={this.mapViewMobile}>Map View</a></li>
                                    </ul>

                                    <ul className="view-list d-none d-md-flex align-items-center">
                                        <li>
                                          <div className="property_sold_fitler"></div>
                                        </li>

                                        {(this?.props?.department === "residential" && this?.props?.search_type === "sales") && 
                                        <li className="d-md-none d-lg-inline-block">
                                            <Link to="/property/commercial/for-sale/in-london" className="commercial-property-link">View Commercial Property</Link>
                                        </li>
                                        }

                                        <li className="property_sortby">
                                            {/* <span className="label-txt d-xl-none">Sort by:</span><Link to="#" className="sort-by">Highest <span className="d-md-none d-xl-inline"> Price First</span> <i className="icon-arrow-dropdown"></i></Link> */}


                                            <div className="search-select-box sortby-dropdown">
                                                <Select
                                                    name="sortby"
                                                    options={[
                                                    { value: index_name+"_price_desc", label: "Highest Price First", path: "sortby-price-desc" },
                                                    { value: index_name+"_price_asc", label: "Lowest Price First", path: "sortby-price-asc" },
                                                    { value: index_name+"_most_recent", label: "Most Recent First", path: "sortby-most-recent" },
                                                    ]}
                                                    placeholder="Highest Price"
                                                    classNamePrefix={"select-opt"}
                                                    isSearchable={false}
                                                    components={{ DropdownIndicator: () => <DownIndicator /> }}
                                                    onChange={this.onChangeSortBy}
                                                />
                                            </div>
                                        </li>
                                        <li className="list-ctrl"><a href="javascript:void(0)" onClick={this.listView}><i className="icon-list"></i> <span className="d-none d-xl-inline">List</span> </a></li>
                                        <li className="map-ctrl"><a href="javascript:void(0)" onClick={this.mapView}><i className="icon-map-active"></i> <span className="d-none d-xl-inline">Map</span></a></li>
                                    </ul>
                                </div>
                                <div className="d-lg-none d-none d-md-block">
                                    <Link to="/property/commercial/for-sale/in-london" className="commercial-property-link">View Commercial Property</Link>
                                </div>
                                <p className="desc d-none d-md-block search_text">Discover a wide range of {search_summarytxt} with Martyn Gerrard Estate Agents. To filter these results, use our filter above, or for more information about {pType} property in <div className="property_area_captialize">{areaName.replace("%20"," ")}</div>, please contact us.</p>
                                </motion.div>
                            )}
                            </InView>

                            <div id="property_list_results" className="cards-wrp property_list_results">
                                {this.state.algoliadata?.hits?.length > 0 &&
                                  <ResultList algoliadata={this.state.algoliadata} location={this.props.location} userObjects={this.state.userObjects} page_url_data={this.state.my_page_url_data} />
                                }
                                {this.state.noResultProperties?.length > 0 && 
                                  <NoResults location={this.props.location} userObjects={this.state.userObjects} noPropertyData={this.state.noResultProperties} />
                                }
                            </div>
                        </div>
                        </Container>
                      </div>

                      <div className="map-scroll map-view-wrap">
                        { (!isMobile) &&
                            <MapResultsDesktop ptype="mySaleProp" />
                        }
                        { (isMobile && this.state.mapview) &&
                        <>                            
                            <MapResultsMobile hits={this.state.algoliadata?.hits} noResultProperties={this.state.noResultProperties} srch_depart={this.props.department}  ptype={this.props.search_type} />
                        </>
                        }
                      </div>                    
                    </section>
                </div>
                <CanHelp />

              <Footer searchtype='sales' popularSearch='propertyresults' searchBedroomfield={searchParams.bedrooms} searchPtype={searchParams.type} Searcharea={searchParams}/>
            </>
        )
    }
}

export default SearchResultTemplate